/**
 * @file Monte la surveillance des déploiements (auto-update des PWA ouvertes).
 * @module apps.dashboard.src.pwa.components.AutoUpdateWatcher
 *
 * Composant sans rendu : délègue toute la logique à useAutoUpdate. Doit être
 * monté une seule fois sous le Router (App.js), au même niveau que les autres
 * composants PWA.
 */

import useAutoUpdate from '../hooks/useAutoUpdate';

/**
 * Active la détection de nouvelle version déployée et le rechargement
 * automatique de l'application aux moments sûrs.
 *
 * @return {null} Aucun rendu
 */
const AutoUpdateWatcher = () => {
  useAutoUpdate();
  return null;
};

export default AutoUpdateWatcher;
